import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { NavigationComponent } from './components/navigation/navigation.component';
import { FooterComponent } from './components/footer/footer.component';
import { PreHeaderComponent } from './components/pre-header/pre-header.component';
import { LeadPopupComponent } from './components/lead-popup/lead-popup.component';
import { WhatsappFabComponent } from './components/whatsapp-fab/whatsapp-fab.component';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavigationComponent, FooterComponent, PreHeaderComponent, LeadPopupComponent, WhatsappFabComponent],
  template: `
    <app-pre-header></app-pre-header>
    <app-navigation></app-navigation>
    <main class="main-content">
      <div class="route-wrapper" [class.animate]="shouldAnimate()" [attr.data-route]="currentRoute()">
        <router-outlet></router-outlet>
      </div>
    </main>
    <app-footer></app-footer>
    <app-lead-popup></app-lead-popup>
    <app-whatsapp-fab></app-whatsapp-fab>
  `,
  styles: [`
    .main-content {
      min-height: calc(100vh - 140px);
      margin-top: 140px;
    }

    @media (max-width: 768px) {
      .main-content {
        min-height: calc(100vh - 70px);
        margin-top: 70px;
      }
    }

    @media (max-width: 480px) {
      .main-content {
        min-height: calc(100vh - 60px);
        margin-top: 60px;
      }
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .route-wrapper.animate {
      animation: fadeInUp 0.5s ease-out;
    }
  `]
})
export class App implements OnInit, OnDestroy {
  private routerSubscription?: Subscription;
  currentRoute = signal('');
  shouldAnimate = signal(false);

  constructor(private router: Router) {}

  ngOnInit() {
    // Set initial route
    this.currentRoute.set(this.router.url);
    this.shouldAnimate.set(true);

    // Scroll to top on route change with smooth animation
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Update route
        this.currentRoute.set(event.urlAfterRedirects);
        // Trigger animation
        this.triggerAnimation();
        // Scroll to top
        this.scrollToTop();
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private triggerAnimation() {
    // Reset animation
    this.shouldAnimate.set(false);
    
    // Force reflow and re-trigger animation
    setTimeout(() => {
      this.shouldAnimate.set(true);
    }, 10);
  }

  private scrollToTop() {
    // Smooth scroll to top with animation
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
